/** The available conversations bulk modal actions labels. */
export const conversationsBulkModalActionLabel = {
    add_internal_note: 'Add internal note',
    add_tag: 'Add tag',
    cancel_csat: 'Cancel CSAT',
    close: 'Close',
    remove_tag: 'Remove tag',
    send_reply: 'Send reply',
    transfer_to_queue: 'Transfer to queue',
};
